import React, { memo, ReactElement } from 'react';
import './Card.css';

export type CardProps = {
  footerText?: ReactElement;
  isGray?: boolean;
};

const Card: React.FC<CardProps> = memo(
  ({ children, footerText, isGray = true }) => {
    return (
      <div data-testid="card--container" className="card--container">
        <div className="card--body">{children}</div>
        {footerText && (
          <div className={isGray ? 'card--footer' : 'card--footer-alternative'}>
            {footerText}
          </div>
        )}
      </div>
    );
  }
);

export default Card;
